import { Typography } from '@mui/material';
import { CopyButton } from '../CopyButton';
import type { InstructionFieldProps } from '../../types';
import InstructionsStyles from './Instructions.style';

const InstructionField = ({
  label,
  value,
  translationKey,
  t,
  showCopyButton = true,
  onCopy,
}: InstructionFieldProps) => {
  if (!value) return null;

  const stringValue = String(value);

  return (
    <div className={InstructionsStyles.fieldRow}>
      <Typography className={InstructionsStyles.instructionsField} noWrap>
        {label}:
      </Typography>
      <div className={InstructionsStyles.instructionsValues}>
        <Typography className={InstructionsStyles.valueText}>
          {stringValue}
        </Typography>
        {showCopyButton && (
          <CopyButton
            label={translationKey}
            value={stringValue}
            t={t}
            onCopy={onCopy}
          />
        )}
      </div>
    </div>
  );
};

export default InstructionField;
